import React from 'react';
import Configuration from '../../components/AdminNext/Configuration';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Configuration — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <Configuration />
      </HeadLessLayout>
    )
  };
}

export default action;
